"use client";

import { LuEllipsis as LuMoreHorizontal } from "react-icons/lu";

import { setDialog } from "@/components/app/dialogs/dialog-provider";
import { Button } from "@/components/ui/button";
import { DIALOG } from "@/utils/dialog-routes";

type CollectionCardManageButtonProps = {
  collectionId: string;
};

export const CollectionCardManageButton = ({
  collectionId,
}: CollectionCardManageButtonProps) => {
  return (
    <Button
      variant="ghost"
      size="icon"
      className="size-8"
      onClick={() => {
        setDialog(DIALOG.CreateCollection, {
          open: true,
          params: {
            collectionId,
          },
        });
      }}
    >
      <LuMoreHorizontal className="size-4" />
      <span className="sr-only">Manage collection</span>
    </Button>
  );
};
